import React, { useContext, useState, memo } from "react"
import styled from "@emotion/styled"
import { breakpoints, color, sizing } from "../../../utils/style"
import Img from "gatsby-image"
import IcomoonIcon from "../../shared/IcomoonIcon"
import PopupIframe, { invokePopup } from "../../shared/PopupIframe"
import LoginFormPopup from "../../Auth/Form/LoginFormPopup"
import ResetLinkFormPopup from "../../Auth/Form/ResetLinkFormPopup"
import StoreContext from "../../shared/Context/StoreContext"

const PlayForFreeWrap = styled("div")`
  .title-block {
    position: relative;
    margin: 1rem 0 2rem;
  }
  .h1 {
    text-transform: uppercase;
  }
  .top-description {
    font-size: 15px;
    line-height: 24px;
  }
  @media (max-width: ${breakpoints.md}) {
    .title-block {
      margin: 0 0 1rem;
    }
    .h1 {
      max-height: 35px;
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    .h1 {
      margin-bottom: 0.7rem;
    }
  }
`

const PlayForFreeAll = styled("div")`
  clear: both;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
`

const PlayForFreeVideo = styled("div")`
  flex-basis: 32%;
  background: ${color.darkRed};
  height: 98.5%;
  position: relative;
  .play-button {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 0;
    right: 0;
    margin: -45px auto 0;
    background: none;
    border: none;
    outline: none;
    cursor: pointer;
    width: fit-content;
    span {
      display: inline-block;
      width: 1px;
      text-indent: -9999px;
    }
    &:hover,
    &:active {
      svg {
        path {
          fill: ${color.brightRed} !important;
        }
      }
    }
  }
  .terms-button {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    margin: 60px auto 0;
    width: 100px;
    z-index: 1;
    visibility: hidden;
  }
  &:hover,
  &:active {
    .terms-button,
    .play-button {
      visibility: visible;
    }
    img {
      filter: brightness(20%);
    }
  }
  @media (max-width: ${breakpoints.md}) {
    .terms-button,
    .play-button {
      visibility: visible;
    }
    .play-button {
      top: 38%;
    }
    .terms-button {
      top: 40%;
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    flex-basis: 100%;
  }
`

const GameAds = styled("div")`
  flex-basis: 68%;
  text-align: right;
  @media (max-width: ${breakpoints.sm}) {
    margin: 12px 0 0 0;
    flex-basis: 100%;
  }
`

const GameAd = styled("div")`
  width: 30%;
  display: inline-block;
  vertical-align: middle;
  margin: 0 0 3% 3.2%;
  position: relative;
  .game-title {
    width: 100%;
    padding: 20px 0;
    text-align: center;
    position: absolute;
    top: 25px;
    left: 0;
    z-index: 1;
    color: ${color.white};
    display: none;
  }
  .show-more,
  .coming-soon {
    width: 120px;
    position: absolute;
    z-index: 1;
    top: 60%;
    left: 0;
    right: 0;
    margin: -25px auto 0;
    display: none;
  }
  .coming-soon {
    background: transparent;
    color: ${color.white};
    padding: 12px;
    text-align: center;
    pointer-events: none;
    width: 150px;
    margin: -25px auto 0;
  }
  .ribbon {
    position: absolute;
    top: 12%;
    right: -5px;
    z-index: 1;
    padding: 5px 10px;
    background: ${color.orange};
    color: ${color.midRed};
    font-weight: bold;
    border-radius: 4px;
  }
  &:hover,
  &:active {
    .ribbon {
      display: none;
    }
    .coming-soon,
    .show-more,
    .game-title {
      display: inline-block;
    }
  }
  a,
  .a {
    display: block;
    &:hover,
    &:active {
      img {
        filter: brightness(20%);
      }
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    width: calc(50% - 12px);
    margin: 12px 0;
    .game-title {
      font-size: ${sizing.small};
      padding: 10px 0;
    }
    &:nth-of-type(odd) {
      margin-right: 12px;
    }
    &:nth-of-type(even) {
      margin-left: 12px;
    }
    .coming-soon {
      font-size: 0.8rem;
    }
  }
`

const PlayForFree = ({
  iframe,
  title,
  description,
  video_cover,
  play_free,
}) => {
  const storeValue = useContext(StoreContext)
  const username = storeValue.username

  const [selectedGameUrl, setSelectedGameUrl] = useState("")
  const setGameUrlState = url => setSelectedGameUrl(prevState => url)
  const [linkData, setLinkData] = useState({
    gameLink: "",
  })

  const gameClick = (e, slide_description, slide_url) => {
    if (!username) {
      e.preventDefault()
      invokePopup(e, "login-popup-window")
      linkData.gameLink = slide_url
      setLinkData({
        gameLink: slide_url,
      })
      localStorage.gameLink = slide_url
      console.log(slide_url)
    }
    setGameUrlState(slide_url)
    if (slide_description) {
      return false
    }
  }

  const videoClick = (e, iframeSrc) => {
    const homeVideoIframe = document.getElementById("free-spin-home-iframe")
    homeVideoIframe.src = iframeSrc
    invokePopup(e, "free-spin-home-popup")
  }

  console.log(iframe);

  return (
    <PlayForFreeWrap id="home-play-for-free" className="home-play-for-free">
      <div className="title-block">
        <h2 className="h1 rich-design">
          <span>{title}</span>
        </h2>
        <div className="decorative-line" />
        <p className="top-description">{description}</p>
      </div>
      <PlayForFreeAll>
        <PlayForFreeVideo>
          {iframe && (
            <button
              className="play-button"
              onClick={e => videoClick(e, iframe)}
            >
              <IcomoonIcon icon="youtube" color={color.lightRed} size={90} />
              <span>Play</span>
            </button>
          )}
          <a
            href={process.env.FREESPIN_TERMS_URL_RELATIVE}
            className="button pink-button terms-button"
          >
            กติกา
          </a>
          {video_cover &&
            video_cover.alt_text &&
            video_cover.localFile &&
            video_cover.localFile.childImageSharp && (
              <Img
                fluid={video_cover.localFile.childImageSharp.fluid}
                alt={video_cover.alt_text}
                fadeIn={false}
                loading="eager"
              />
            )}
        </PlayForFreeVideo>
        <GameAds>
          {play_free.map(item => {
            const localFile = item.localFile || {}
            return (
              <GameAd key={item.path}>
                {item.acf.slide_title && (
                  <span className="ribbon">{item.acf.slide_title}</span>
                )}
                {item.acf.slide_description && (
                  <span className="coming-soon">
                    {item.acf.slide_description}
                  </span>
                )}
                {item.acf.slide_url ? (
                  <a
                    onClick={e => {
                      gameClick(
                        e,
                        // item.title,
                        // item.alt_text,
                        item.acf.slide_description,
                        item.acf.slide_url
                      )
                    }}
                    href={item.acf.slide_url}
                    title={item.alt_text}
                  >
                    {!item.acf.slide_description && item.alt_text && (
                      <span className="game-title">{item.alt_text}</span>
                    )}
                    {!item.acf.slide_description && (
                      <span className="button pink-button show-more">
                        เล่นเลย
                      </span>
                    )}
                    {localFile.childImageSharp &&
                      localFile.childImageSharp &&
                      item.alt_text && (
                        <Img
                          fluid={localFile.childImageSharp.fluid}
                          alt={item.alt_text}
                          fadeIn={false}
                          loading="eager"
                        />
                      )}
                  </a>
                ) : (
                  <div className="a">
                    {localFile.childImageSharp &&
                      localFile.childImageSharp &&
                      item.alt_text && (
                        <Img
                          fluid={localFile.childImageSharp.fluid}
                          alt={item.alt_text}
                          fadeIn={false}
                          loading="eager"
                        />
                      )}
                  </div>
                )}
              </GameAd>
            )
          })}
        </GameAds>
        {iframe && (
          <PopupIframe
            title="Free Spin"
            popupId="free-spin-home-popup"
            extraClass="wide"
          >
            <div className="iframe-container">
              <iframe
                id="free-spin-home-iframe"
                title="Free Spin"
                src="about:blank"
                allow="accelerometer; clipboard-write; encrypted-media; gyroscope;"
                allowFullScreen={true}
                frameBorder={0}
              />
            </div>
          </PopupIframe>
        )}
        {!username && (
          <div>
            <LoginFormPopup
              popupId="login-popup-window"
              redirectUrl={selectedGameUrl}
            />
            <ResetLinkFormPopup popupId="reset-link-popup" />
          </div>
        )}
      </PlayForFreeAll>
    </PlayForFreeWrap>
  )
}

export default memo(PlayForFree);
